/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import {
  MATRIX_CLIENT_FAILED,
  MATRIX_CLIENT_READY,
  MATRIX_UI_READY,
} from '../actionTypes/client'

const initialState = {
  client: false,
  clientFailed: false,
  ui: false,
}

export default createActionTypeReducer(
  {
    [MATRIX_CLIENT_READY]: draftState => {
      draftState.client = true
      draftState.clientFailed = false
      return draftState
    },
    [MATRIX_CLIENT_FAILED]: draftState => {
      draftState.client = false
      draftState.clientFailed = true
      return draftState
    },
    [MATRIX_UI_READY]: draftState => {
      draftState.ui = true
      return draftState
    },
  },
  initialState
)
